import React from 'react'
import './Elips.css'

const Elips = () => {
  return (
    <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
  )
}

export default Elips